import React from 'react';
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';

import RadioListItem from '../RadioListItem';

import Wrapper from './Wrapper';
import List from './List';

function RadioList(props) {
  return (
    <Wrapper>
      {props.items.length > 0 && (
        <List>
          {props.items.map((item) => {
            const id = String(item.id);

            return (
              <RadioListItem
                key={id}
                id={id}
                item={item}
                selected={id === String(props.selectedItemId)}
                onClick={props.onItemClick}
              />
            );
          })}
        </List>
      )}

      {props.errors.map(message => (
        <div key={message} role="alert">
          {message} <span role="img" aria-label="Взрыв">💥</span>
        </div>
      ))}

      {!props.loading && !props.errors.length && props.items.length === 0 && (
        <div>{props.errorMessages.empty}</div>
      )}

      {props.loading && <div>{props.errorMessages.loading}</div>}

      {!props.loading && !props.errors.length && props.next && (
        <Waypoint key={props.pageNumber} onEnter={props.onWaypointEnter} />
      )}
    </Wrapper>
  );
}

RadioList.propTypes = {
  selectedItemId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  items: PropTypes.arrayOf(PropTypes.shape({})),
  loading: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  next: PropTypes.bool,
  pageNumber: PropTypes.number,

  errorMessages: PropTypes.shape({
    loading: PropTypes.string,
    empty: PropTypes.string,
  }),

  onItemClick: PropTypes.func,
  onWaypointEnter: PropTypes.func,
};

RadioList.defaultProps = {
  selectedItemId: '',

  items: [],
  loading: false,
  errors: [],
  next: true,
  pageNumber: 0,

  errorMessages: {
    loading: 'Загрузка... 🚚',
    empty: 'Нет данных 😢',
  },

  onItemClick: () => {},
  onWaypointEnter: () => {},
};

export default RadioList;
